import React from 'react';
import {
  RequireNewPassword as BaseRequireNewPassword
} from 'aws-amplify-react';
import AuthWrapper from './AuthWrapper';
import RequireNewPasswordForm from './RequireNewPassword/RequireNewPasswordForm';

export default class RequireNewPassword extends BaseRequireNewPassword {
  componentDidUpdate(prevProps) {
    if (prevProps.authState !== this.props.authState && prevProps.authState === 'requireNewPassword') {
      this.setState({
        working: false,
        errorMessage: false
      });
    }
  }

  error = errorMessage => {
    setTimeout(() => {
      this.setState({
        working: false,
        errorMessage: this.errorMessage(errorMessage)
      });
    }, 1000);
  };

  handleSubmit = ({password }) => {
    this.inputs.password = password;

    this.setState({
      working: true,
      errorMessage: false,
    }, () => {
      this.change();
    });
  };

  showComponent() {
    const {
      hide
    } = this.props;
    const {
      errorMessage = false,
      working = false
    } = this.state || {};

    if (hide && hide.includes(RequireNewPassword)) {
      return null;
    }

    return (
      <AuthWrapper
        title="New Password Required"
      >
        <RequireNewPasswordForm
          onSubmit={this.handleSubmit}
          changeState={this.changeState}
          errorMessage={errorMessage}
          working={working}
        />
      </AuthWrapper>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Authentication/RequireNewPassword.js